import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMessage } from "sr/utils/api/cleaner/getMessage";
export const fetchChat = createAsyncThunk('chat', async (params:any)=>{
const queryParams = new URLSearchParams()
queryParams.append('recipient_id', params?.userId)
const query = {
                        $or: [
                            { sender_id_type: "system" }
                        ]
                    };
             queryParams.append('filter', JSON.stringify(query))
             queryParams.append('readed', 'false')          
             queryParams.append('limit', 1000?.toString())
     try{
        const res = await getMessage(queryParams)
                   if(res?.success===true) {
                    return res?.data;
                }
                   else {
                   
                   }
     }  
     catch(e:any){

     }                       
})

interface ChatState {
data: any,

    isLoading:boolean,
    isError:boolean
}
const initialState:ChatState = {
    isLoading:false,
    data: null,
    isError:false
}
const ChatSlice = createSlice({
   name:'Chat',
   initialState,
   
   extraReducers:(builder)=>{
           builder.addCase(fetchChat.pending, (state, action)=>{
                   state.isLoading = true
           })
                       builder.addCase(fetchChat.fulfilled, (state, action) => {
   
                           
                           state.data = action.payload;
                       })
                       builder.addCase(fetchChat.rejected, (state, action) => {
                           state.isError = true;
           
                       });
       },
       reducers: {
    updateSystemMessage: (state, action) => {
      state.data = action.payload;
    },
       removeNotificationMessage:(state, action)=>{
            if(action?.payload?.id){
            state.data = state?.data?.filter((item)=> item?._id !== action?.payload?.id)
        }
        else {
            state.data = []
        }
        },
        markNotificationAsRead: (state, action) => {
            const { id, jobId, senderId, messageText, fileId } = action.payload;
            state.data = state?.data?.map((m: any) => {
                const mJobId = typeof m.job_id === 'string' ? m.job_id : (m.job_id?._id || m.job_id?.id);
                const mSenderId = typeof m.sender_id === 'string' ? m.sender_id : (m.sender_id?._id || m.sender_id?.id);
                const mFileId = typeof m.file_id === 'string' ? m.file_id : (m.file_id?._id || m.file_id?.id);
                const isTempId = m._id && m._id.toString().startsWith('temp_');

                if (m._id === id || ((!m._id || isTempId) && mJobId === jobId && mSenderId === senderId && m.message === messageText && mFileId === fileId)) {
                    return { ...m, readed: true };
                }
                return m;
            });
        }
  },

})
export const { updateSystemMessage, removeNotificationMessage, markNotificationAsRead } = ChatSlice.actions;
export default ChatSlice.reducer